<div class="filter-bar">
  <div *ngFor="let filterItem of filterBar.filterBarItems" class="filter-item">

    <!-- Viewing/Interacting Portion -->
    <div *ngIf="!isEditing" class="filter-item">

      <ng-container> <!--*ngIf="getFilterValues(filterItem.filterName) as options"-->
        <div class="filter-item-clickable"
        [ngClass]="{ 'selected-filter-item': filterItem.ordinal === selectedItemOrdinal }"
        (click)="onFilterItemClick(filterItem.ordinal, filterItem)">{{filterItem.filterName}}</div>
      </ng-container>
    </div>

    <!-- Editing Portion -->
    <ng-container *ngIf="isEditing" >
      <div class="vertical-items">
        <input [placeholder]="'Filter Group Name'" [(ngModel)]="filterItem.filterName" />

        <mat-form-field appearance="fill">
          <ng-container>
            <mat-select
              [placeholder]="'Dataset'"
              [(ngModel)]="filterItem.datasetId"
              (selectionChange)="onDatasetChange(filterItem)"
            >
              <mat-option
                *ngFor="let dataset of datasets"
                [value]="dataset.datasetReferenceTable.datasetId"
              >
                {{ dataset.datasetReferenceTable.datasetName }}
              </mat-option>
            </mat-select>
          </ng-container>
        </mat-form-field>
        <ng-container *ngIf="fieldNamesFromResponseMap[filterItem.datasetId] as fieldNames">
          <mat-form-field appearance="fill">
            <mat-select
              [placeholder]="'Field to Display'"
              [(ngModel)]="filterItem.fieldNameToDisplay"
              (selectionChange)="onFieldNameToDisplayChange(filterItem)"
            >
              <mat-option
                *ngFor="let option of fieldNames"
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </div>
      <div class="vertical-items">
        <mat-form-field appearance="fill"  class="compact-form-field">
          <ng-container>
            <!-- <mat-label>Filter Selection Type</mat-label> -->
            <mat-select
              [(ngModel)]="filterItem.filterBarItemType"
              (selectionChange)="onDatasetChange(filterItem)"
            >
              <mat-option
                *ngFor="let filterBarItemType of filterBarItemTypes"
                [value]="filterItem.filterBarItemType"
              >
                {{ filterBarItemType }}
              </mat-option>
            </mat-select>
          </ng-container>
        </mat-form-field>
        <mat-form-field appearance="fill" class="compact-form-field">
          <ng-container>
            <!-- <mat-label>Filter Selection Type</mat-label> -->
            <mat-select
              [(ngModel)]="filterItem.filterSelectionType"
              (selectionChange)="onDatasetChange(filterItem)"
            >
              <mat-option
                *ngFor="let filterSelectionType of filterSelectionTypes"
                [value]="filterItem.filterSelectionType"
              >
                {{ filterSelectionType }}
              </mat-option>
            </mat-select>
          </ng-container>
        </mat-form-field>

      </div>
      <button mat-raised-button class="remove-filter-item-but" *ngIf="isEditing"  (click)="onDeleteFilterBarItem(filterItem)">
        X
      </button>

    </ng-container><!-- End editing -->
  </div>
  <button mat-raised-button class="add-filter-group-but" *ngIf="isEditing" (click)="addFilterGroup()">
    Add Filter Group
  </button>

  <div class="filter-dropdown"  [style.width]="dropdownWidth" *ngIf="!isEditing && selectedFilter && treeMap[selectedFilter.filterName] && showFilterDropdown">
    <bhub-tree-view class="bhub-tree-class"
    [nodes]="treeMap[selectedFilter.filterName]"
    [(selectedNodes)]="selectedTreeNodeMap[selectedFilter.filterName]"
    [selectionType]="selectedFilter.filterSelectionType"
    ></bhub-tree-view>
  </div>

</div>

        <!-- [multiple]="filterItem === 'Multiple Pick'" -->
